import { render, staticRenderFns } from "./AlbumGalleryZone.vue?vue&type=template&id=21e31db6&scoped=true&"
import script from "./AlbumGalleryZone.vue?vue&type=script&lang=js&"
export * from "./AlbumGalleryZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumGalleryZone.vue?vue&type=style&index=0&id=21e31db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e31db6",
  null
  
)

export default component.exports